import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function pushCreative(data) {
  return request({
    url: `${v2Host}/creative/push/submit`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export function getPushHistory(params) {
  return request({
    url: `${v2Host}/creative/push/history`,
    method: 'get',
    params,
  })
}

export function getPushAccountList(params) {
  return request({
    url: `${v2Host}/creative/push/accounts`,
    method: 'get',
    params,
  })
}

export function addPushAccount(data) {
  return request({
    url: `${v2Host}/creative/push/add-account`,
    method: 'post',
    data,
  })
}

export function getPushDownloadHistory(params) {
  return request({
    url: `${v2Host}/creative/download/history`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function exportPushdownloadHistory(params) {
  return request({
    url: `${v2Host}/creative/download/export-history`,
    method: 'get',
    params,
  })
}
